import React, { useEffect, useState } from "react";
import { Header, Grid, Divider, Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Swal from "sweetalert2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";

const ListPerformaInvoice = () => {
  const navigate = useNavigate();
  const userDetail = userData();
  const [rowData, setrowData] = useState(null);

  useEffect(() => {
    getinvoiceList();
  }, []);

  const createNew = () => {
    navigate("/new-performa-invoice/null");
  };

  const getinvoiceList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listPerformaInvoice", { getAll: true })
      .then((res) => {
        setRecordForTable(res.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setRecordForTable = (record) => {
    const tempRecord = record.map((item) => ({
      ssPerformaInvoiceId: item.ssPerformaInvoiceId,
      invoiceDate: item.invoiceDate
        ? new Date(item.invoiceDate).toLocaleDateString("en-GB")
        : "",
      invoiceName: item.invoiceName,
      customerContact: item.customerContact,
      email: item.email,
      invoiceNumber: item.invoiceNumber,
      personName: item.personName,
      workName: item.workName,
      totalAmount: item.totalAmount,
    }));
    setrowData(tempRecord);
  };

  const actionButton = (params) => {
    navigate(
      `/new-performa-invoice/${params.data.ssPerformaInvoiceId}`
    );
  };

  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "accounts/deletePerformaInvoice", {
            ssPerformaInvoiceId: params.data.ssPerformaInvoiceId,
          })
          .then((res) => {
            if (res.data.errCode === 200) {
              Swal.fire(
                "Deleted!",
                "All Attractions has been deleted.",
                "success"
              );
              getinvoiceList();
            } else {
              Swal.fire("Error", res.data.errMessage || "Failure", "error");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const columnDefs = [
    { headerName: "ID", field: "ssPerformaInvoiceId", flex: 1 },
    { headerName: "Date", field: "invoiceDate", flex: 2 },
    { headerName: "Customer Name", field: "invoiceName", flex: 3 },
    { headerName: "Mobile", field: "customerContact", flex: 2 },
    { headerName: "Email", field: "email", flex: 3 },
    {
      field: "invoiceNumber",
      headerName: "Invoice NO",
      flex: 2,
      cellRendererFramework: (params) => (
        <div style={{ cursor: "pointer" }} onClick={() => actionButton(params)}>
          {params.value}
        </div>
      ),
    },
    { headerName: "Person Name", field: "personName", flex: 3 },
    { headerName: "Work", field: "workName", flex: 2 },
    { headerName: "Total", field: "totalAmount", flex: 2 },
    {
      headerName: "Actions",
      filter: false,
      field: "ssPerformaInvoiceId",
      flex: 3,
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            View
          </Button>
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: false,
    filter: true,
    floatingFilter: true,
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          All Attractions
        </Header>
      </Grid.Row>
      <Divider hidden />
      <Grid.Row>
        <div>
          <Button type="button" primary onClick={() => createNew()}>
            Create New
          </Button>
          {rowData !== null && (
            <Button
              color="primary"
              onClick={() => exportToCSV(rowData, "All_Attractions_List")}
            >
              Download CSV
            </Button>
          )}
        </div>
      </Grid.Row>
      <Divider hidden />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListPerformaInvoice;
